import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContactTypeInput, ContactTypeResult, GetContactTypesInput, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class ContactTypeService {

  constructor(private httpClient: HttpClient) { }

  public addContactType(contactTypeInput: ContactTypeInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'ContactType/AddContactType', contactTypeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editContactType(id: number, contactTypeInput: ContactTypeInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'ContactType/EditContactType?id=' + id, contactTypeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteContactType(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'ContactType/DeleteContactType?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getContactTypes(getContactTypesInput: GetContactTypesInput, token: string): Promise<ResultList<ContactTypeResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'ContactType/GetContactTypes', getContactTypesInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ContactTypeResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ContactTypeResult>(), result.error));
  }
}
